import { TypePolicy } from "@apollo/client";

export default {
  keyFields: ["slideId"],
} as TypePolicy;
